// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","white":"Card_white__a5FQo","pink":"Card_pink__frb6F","black":"Card_black__P1SuH","gray":"Card_gray__JPtar"};